import { loadAvailableCapacityCounts } from '../redux/capacity';
import { createLoadCountry } from 'event-widgets/redux/modules/country';
import { registerTranslation } from 'nucleus-guestside-site/src/redux/modules/text';
import { loadState } from 'event-widgets/redux/modules/state';
import getJSONValue from 'nucleus-widgets/utils/fields/getJSONValue';
import { getContactFieldJsonPath as getContactFieldJsonPathSelector } from '../redux/selectors/event';
import { loadHotelsRoomsCapacities } from 'event-widgets/redux/modules/eventTravel';
import { loadAllCurrencies } from '../redux/currencies';
import { populateAllProducts, populateAllProductsByRegistrationType } from '../redux/visibleProducts';
import { updateAppDataForRoommateSettings } from '../redux/appData';

const loadCountry = () => {
  return async (dispatch) => {
    await dispatch(createLoadCountry(registerTranslation));
  };
};

function getContactFieldJsonPath(state, widgetId, config, fieldName) {
  return getContactFieldJsonPathSelector(state, widgetId, config.registrationFieldPageType, config.fieldId, fieldName);
}
export default (widgets) => {
  return async (dispatch, getState) => {
    const resourceLoaders = {};
    // This function is called once per page and there could be more than one widget of same type in widgets array.
    // Since we only want to load resources once per page, we are only setting resourceLoaders once per
    // widget types that requires it. This allows us to dispatch resouce loading functions once
    // (ex. loadAvailableCapacityCounts)
    widgets.forEach(widget => {
      switch (widget.widgetType) {
        case 'RegistrationSummary':
          resourceLoaders.currencies = loadAllCurrencies;
          resourceLoaders.country = loadCountry;
          resourceLoaders.widget = () => populateAllProducts('Widget');
          break;
        case 'Payment':
          resourceLoaders.country = loadCountry;
          resourceLoaders.widget = () => populateAllProducts('Widget');
          break;
        case 'RegistrationCancellationRefund':
          resourceLoaders.widget = () => populateAllProducts('Widget');
          break;
        case 'EventStandardContactFieldChoice':
        case 'EventLocation': {
          resourceLoaders.country = loadCountry;
          break;
        }
        case 'EventStandardContactFieldAddress': {
          resourceLoaders.country = loadCountry;

          // Get the states for the default country defined in the widget.
          const defaultCountryLocation =
            getContactFieldJsonPath(getState(), widget.id, widget.config, 'defaultCountry');
          const defaultCountry = getJSONValue(getState().appData, defaultCountryLocation);
          // In case there are multiple widgets and they have different default countries we will scope the loading to
          // the specific country.
          resourceLoaders[`state-${defaultCountry}`] = () => loadState(registerTranslation, defaultCountry.value);
          break;
        }

        case 'RegistrationType':
        case 'Sessions':
        case 'QuantityItems':
          resourceLoaders.capacity = loadAvailableCapacityCounts;
          break;
        case 'AdmissionItems':
          resourceLoaders.capacity = loadAvailableCapacityCounts;
          if (widget.config.display && widget.config.display.limitByRegistrationType) {
            resourceLoaders.widget = () => populateAllProductsByRegistrationType('Widget');
          } else {
            resourceLoaders.widget = () => populateAllProducts('Widget');
          }
          break;
        case 'Agenda':
          resourceLoaders.capacity = loadAvailableCapacityCounts;
          if (widget.config.display && widget.config.display.limitByRegistrationType) {
            resourceLoaders[`Agenda:${widget.id}`] = () => populateAllProductsByRegistrationType('Agenda', widget.id);
          } else {
            resourceLoaders[`Agenda:${widget.id}`] = () => populateAllProducts('Agenda', widget.id);
          }
          break;
        case 'HotelRequest':
          resourceLoaders.newHotelData = () => loadHotelsRoomsCapacities();
          resourceLoaders.roommateMatchingSettings = () =>
            updateAppDataForRoommateSettings(widget.config.roommateSetupSettings);
          break;
        case 'AirActual':
        case 'AirActualSummary':
        case 'FlightItinerarySummary':
          resourceLoaders.currencies = loadAllCurrencies;
          break;
        case 'InviteeAgenda':
          resourceLoaders[`InviteeAgenda:${widget.id}`] = () => populateAllProducts('InviteeAgenda', widget.id);
          break;
        case 'ApptsAvailability':
          resourceLoaders.widget = () => populateAllProducts('Widget');
          break;
        default:
          // Nothing to do for widgets that don't require resources to be loaded.
      }
    });
    const resourceLoaderPromises = Object.values(resourceLoaders).map(resourceLoader => dispatch(resourceLoader()));
    await Promise.all(resourceLoaderPromises);
  };
};
